import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';
import { startSubmit, stopSubmit } from 'redux-form';

import { getIntl } from '@ackee/jerome/antd';

import message from 'antd/lib/message';

import config from 'config/index';
import filterUndefined from 'utilities/filterUndefined';
import mergeEmpty from 'utilities/mergeEmpty';

import * as loglevel from 'config/loglevel';

import types from '../../actionTypes';
import { infoDetailRequest } from '../../actions';

const { takeEvery, put, take } = sagaEffects;

function* handler({ payload, meta }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    yield put(startSubmit(meta.form));
    try {
        const defaultValues = filterUndefined(payload[config.app.defaultLanguage]);
        const batch = firestore.batch();

        let ref = yield firestore.doc(
            `languages/${config.app.defaultLanguage}/infoCategories/${meta.categoryId}/info/${meta.id}`,
        );
        batch.update(ref, defaultValues);

        const languages = config.app.languages.filter(l => l !== config.app.defaultLanguage);
        for (const lang of languages) {
            const data = filterUndefined(mergeEmpty({}, defaultValues, payload[lang]));
            ref = yield firestore.doc(`languages/${lang}/infoCategories/${meta.categoryId}/info/${meta.id}`);
            batch.update(ref, data);
        }

        yield batch.commit();

        yield put(infoDetailRequest(meta.categoryId, meta.id, true));
        yield take(types.INFO_DETAIL_REQUEST_COMPLETED);
        yield put(stopSubmit(meta.form));
        message.success(intl.formatMessage({ id: 'success.info.update' }));
    } catch (e) {
        yield put(stopSubmit(meta.form, { _error: 'errors.info.update' }));
        loglevel.error(e);
    }
}
export default function* () {
    yield takeEvery(types.UPDATE_INFO_REQUEST, handler);
}
